import {
	type Action,
	TOGGLE_EPIC_FIELDS,
	TOGGLE_STATUS_FIELDS,
	TOGGLE_VERSION_FIELDS,
} from '../../../../actions/cards/fields';
import type { FieldsState } from './types';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { Action };

const initialState: FieldsState = {
	isStatusFieldsHidden: false,
	isVersionFieldsHidden: false,
	isEpicFieldsHidden: false,
};
export const fieldsReducer = (
	state: FieldsState | undefined = initialState,
	action: Action,
): FieldsState => {
	if (action.type === TOGGLE_STATUS_FIELDS) {
		return {
			...state,
			isStatusFieldsHidden: action.payload.hideStatusFields,
		};
	}

	if (action.type === TOGGLE_VERSION_FIELDS) {
		return {
			...state,
			isVersionFieldsHidden: action.payload.hideVersionFields,
		};
	}

	if (action.type === TOGGLE_EPIC_FIELDS) {
		return {
			...state,
			isEpicFieldsHidden: action.payload.hideEpicFields,
		};
	}

	return state;
};
